/**
 * Composable for loading the PayPal SDK script dynamically.
 *
 * @returns {UseScriptReturn | false} The script loading result or false if no client ID is available.
 * @description Loads the PayPal SDK script with messages and buttons components.
 * @example
 * // Load PayPal script
 * const paypalScript = usePaypalScript()
 * if (paypalScript) {
 *   // PayPal script is ready to use
 * }
 */
export const usePaypalScript = () => {
  const config = useRuntimeConfig()
  const clientId = config.public.paypal.clientId

  // Return false if no client ID is configured
  if (!clientId) return false

  return useScript({
    src: `https://www.paypal.com/sdk/js?client-id=${clientId}&components=messages,buttons`,
    'data-namespace': 'PayPalSDK',
    key: 'Paypal',
    // type: 'text/partytown',  // Uncomment if using Partytown
    defer: true,
  })
}
